export default function cloneState(state, newState) {
	return { ...state, ...newState };
}
